import { ComponentProps } from 'react'

import { CSSProps, VariantProps } from 'ui'

import Box from 'components/atomic/atoms/box'
import BoxStyled from 'components/atomic/atoms/box/box.styled'

const BackgroundSquares = ({
  css,
  as = 'svg',
  width = 640,
  height = 605,
  fill = 'none',
  ...props
}: VariantProps<typeof BoxStyled> &
  ComponentProps<typeof BoxStyled> &
  CSSProps & {
    as?: 'svg'
    width?: number
    height?: number
    fill?: string
  }) => {
  return (
    // @ts-ignore, types just go crazy
    <Box
      as={as}
      width={width}
      height={height}
      fill={fill}
      css={{
        opacity: 0.9,
        '.dark &': {
          opacity: 0.1
        },
        ...css
      }}
      {...props}
    >
      <path opacity={0.3} stroke="url(#a)" d="M160.5 0v605" />
      <path opacity={0.6} stroke="url(#b)" d="M240.5 0v605" />
      <path opacity={0.7} stroke="url(#c)" d="M320.5 0v605" />
      <path opacity={0.8} stroke="url(#d)" d="M400.5 0v605" />
      <path opacity={0.9} stroke="url(#e)" d="M480.5 0v605" />
      <path stroke="url(#f)" d="M560.5 0v605" />
      <path stroke="url(#g)" d="M0 159.5h640" />
      <path stroke="url(#h)" d="M0 239.5h640" />
      <path stroke="url(#i)" d="M0 319.5h640" />
      <path stroke="url(#j)" d="M0 399.5h640" />
      <path opacity={0.4} stroke="url(#k)" d="M0 479.5h640" />
      <defs>
        <linearGradient
          id="a"
          x1={160}
          y1={605}
          x2={160}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171D1E" stopOpacity={0.3} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.734} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="b"
          x1={240}
          y1={605}
          x2={240}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.556} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="c"
          x1={320}
          y1={605}
          x2={320}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171D1E" stopOpacity={0.3} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.372} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="d"
          x1={400}
          y1={605}
          x2={400}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171D1E" stopOpacity={0.3} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.676} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="e"
          x1={480}
          y1={605}
          x2={480}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#171D1E" stopOpacity={0.3} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.587} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="f"
          x1={560}
          y1={605}
          x2={560}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0} stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.636} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="g"
          x1={0}
          y1={160}
          x2={640}
          y2={160}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.834} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="h"
          x1={0}
          y1={240}
          x2={640}
          y2={240}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.764} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="i"
          x1={0}
          y1={320}
          x2={640}
          y2={320}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.582} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="j"
          x1={0}
          y1={400}
          x2={640}
          y2={400}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.492} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
        <linearGradient
          id="k"
          x1={0}
          y1={480}
          x2={640}
          y2={480}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity={0.2} />
          <stop offset={0.641} stopColor="#C1DFDC" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
        </linearGradient>
      </defs>
    </Box>
  )
}

export default BackgroundSquares
